/* @jsx h */
import { defineComponent, h } from "vue";

export const AIAnimation = defineComponent({
  name: "AIAnimation",
  setup() {
    return () => (
      <div class="ai-animation group relative inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-accent/10 text-accent">
        <span
          class="material-symbols-outlined ai-star ai-star--main"
          style="font-size:26px"
        >
          auto_awesome
        </span>
        <span
          class="material-symbols-outlined ai-star ai-star--small ai-star--top"
          style="font-size:12px"
        >
          auto_awesome
        </span>
        <span
          class="material-symbols-outlined ai-star ai-star--small ai-star--bottom"
          style="font-size:10px"
        >
          auto_awesome
        </span>

        <style>{`
          .ai-animation {
            isolation: isolate;
          }
          .ai-star {
            display: inline-flex;
            transform-origin: center;
          }
          .ai-star--main {
            animation: ai-pulse 2.6s ease-in-out infinite;
          }
          .ai-star--small {
            position: absolute;
            opacity: 0;
          }
          .ai-star--top {
            top: 4px;
            right: 6px;
            animation: ai-twinkle-a 2.6s ease-in-out infinite;
          }
          .ai-star--bottom {
            bottom: 6px;
            left: 7px;
            animation: ai-twinkle-b 2.6s ease-in-out infinite;
            animation-delay: 0.6s;
          }

          @keyframes ai-pulse {
            0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; }
            50% { transform: scale(1.12) rotate(8deg); opacity: 0.85; }
          }
          @keyframes ai-twinkle-a {
            0%, 20% { opacity: 0; transform: scale(0.4) rotate(-10deg); }
            45% { opacity: 1; transform: scale(1) rotate(0deg); }
            70%, 100% { opacity: 0; transform: scale(0.4) rotate(10deg); }
          }
          @keyframes ai-twinkle-b {
            0%, 20% { opacity: 0; transform: scale(0.4) rotate(10deg); }
            45% { opacity: 1; transform: scale(1) rotate(0deg); }
            70%, 100% { opacity: 0; transform: scale(0.4) rotate(-10deg); }
          }

          .ai-animation:hover .ai-star--main {
            animation: ai-pulse-fast 0.9s ease-in-out infinite;
          }
          .ai-animation:hover .ai-star--top {
            animation: ai-twinkle-a 0.9s ease-in-out infinite;
          }
          .ai-animation:hover .ai-star--bottom {
            animation: ai-twinkle-b 0.9s ease-in-out infinite;
            animation-delay: 0.2s;
          }
          @keyframes ai-pulse-fast {
            0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; }
            50% { transform: scale(1.2) rotate(12deg); opacity: 0.85; }
          }
        `}</style>
      </div>
    );
  },
});
